import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import Communications from '../../../images/Communications.svg';
import MarkFollowUp from '../../../images/MarkFollowUp.svg';
import { CloseSquareTwoTone } from '@ant-design/icons';
import SendCommsModal from "./SendCommsModal";
import FollowUpModal from "./MarkFollowUpModal";
import CancelOrderModal from "./CancelOrderModal";
import { pharmacyOpsActions } from "../../../constant";


const PharmacyActions = ({orderId, allowedActions}) => {
    const [showSendCommsPopup, setShowSendCommsPopup] = React.useState(false);
    const [showFollowUpPopup, setShowFollowUpPopup] = React.useState(false);
    const [showCancelOrderPopup, setShowCancelOrderPopup] = React.useState(false);

    const handlePopUps = (action) => {
        console.log('vnd',action)
        if( action == 'send-comms'){
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(false);
            setShowSendCommsPopup(true);
        }else if (action == 'mark-follow-up'){
            setShowSendCommsPopup(false);
            setShowCancelOrderPopup(false);
            setShowFollowUpPopup(true);
        }else if(action == 'close-popup'){
            setShowSendCommsPopup(false);
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(false);
        }else if(action == 'cancel-order'){
            setShowSendCommsPopup(false);
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(true);
        }
    }

    return (
        <>
            <div style={{ display : 'flex', justifyContent : 'space-evenly', alignItems : 'center' }}>
                <div>
                        <UncontrolledTooltip target={`pharmacy-cancel-order-${orderId}`}>
                            Cancel Order
                        </UncontrolledTooltip>
                        <CloseSquareTwoTone
                            id={`pharmacy-cancel-order-${orderId}`}
                            onClick={() => allowedActions.includes(pharmacyOpsActions.CANCEL_ORDER) && handlePopUps('cancel-order')}
                            twoToneColor={['#000000', '#f5f5f5']}
                            style={{
                                fontSize: '1.6rem',
                                cursor: !allowedActions.includes(pharmacyOpsActions.CANCEL_ORDER) ? 'not-allowed' : 'pointer',
                                pointerEvents: !allowedActions.includes(pharmacyOpsActions.CANCEL_ORDER) ? 'none' : 'auto',
                                opacity: !allowedActions.includes(pharmacyOpsActions.CANCEL_ORDER) ? 0.5 : 1,
                            }}
                            className="button-img"
                        />
                </div>
            <div>
                <UncontrolledTooltip  target= {`pharmacy-action-send-comms-${orderId}`}>
                    Send Communication
                </UncontrolledTooltip>
                <img
                    id={`pharmacy-action-send-comms-${orderId}`}
                    onClick={() => handlePopUps('send-comms')}
                    src={Communications}
                    alt="Send Communication"
                    className="button-img"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                />  
            </div>
            <div>
                <UncontrolledTooltip  target= {`pharmacy-action-mark-follow-up-${orderId}`}>
                    Mark Follow Up
                </UncontrolledTooltip>
                <img
                    id={`pharmacy-action-mark-follow-up-${orderId}`}
                    onClick={() => handlePopUps('mark-follow-up')}
                    src={MarkFollowUp}
                    alt="Mark Follow Up"
                    className="button-img"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                />  
            </div>
    
            </div>
            {showCancelOrderPopup && <div> <CancelOrderModal orderId = {orderId} onClose={handlePopUps} /></div>}
            {showSendCommsPopup && <div> <SendCommsModal orderId = {orderId} onClose={handlePopUps} /></div>}
            {showFollowUpPopup && <div> <FollowUpModal isOpen = {true} orderId = {orderId} onClose={handlePopUps} /></div>}
        </>

    )

}
export default PharmacyActions;